import * as React from "react";
import { useEffect } from "react";
import { ApplyModel } from "../../../../../../../Wrap/Models/Models/Processes/Apply/ApplyModel";
import { BankAccountOwner } from "../../../../../../../Wrap/Constants/Enums/Domain/BankAccountOwner";
import { Action } from "../../../../../Actions/Action";
import { BankAccountCheckRequest } from "../../../../../../../Wrap/Models/Domains/BankAccount/BankAccountCheckRequest";
import { getQueryParameters } from "../../../../../../Shared/Wizards/Entities/QueryParametersHelper";

export const BWACheck = (props: { extraInfo }) => {
    const { extraInfo } = props;

    useEffect(() => {
        checkBankAccountWithBWA(extraInfo);
    }, []);

    const checkBankAccountWithBWA = (model: ApplyModel) => {
        const requests = new Array<BankAccountCheckRequest>();
        const filterBankAccountInstructions = model?.BankAccountInstructions?.filter(
            (f) => f.Owner == BankAccountOwner.Individual || f.Owner == BankAccountOwner.Joint
        );
        if (filterBankAccountInstructions != null) {
            filterBankAccountInstructions.forEach((ele) => {
                const request: BankAccountCheckRequest = {
                    ActorId: model?.ClientDetails?.ActorId,
                    ClAccountId: model.ClAccountId ? model.ClAccountId : getQueryParameters()["claccountid"],
                    AccountNumber: ele.AccountNumber,
                    SortCode: ele.BankCodes.BankCode + ele.BankCodes.BranchCode + ele.BankCodes.ExtraCode,
                    RollNumber: ele.RollNumber,
                    NominatedForDirectDebit: ele.NominatedForDirectDebit,
                    NominatedForWithdrawal: ele.NominatedForWithdrawal,
                    Owner: ele.Owner,
                };
                requests.push(request);
            });
            Action.ExperianBankAcountCheck(requests);
        }
    };

    return <></>;
};
